import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography, Grid, Button, Chip, CircularProgress, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useStyles } from "./styles";
import { useGetData } from "../../hooks/useGetData";
import { ObjectGeneric, onChangeEvent } from "../../../../../../../../utils/types/generals";
import { FormContext, SubcategoryInterface, CategoryInterface, SelectedSubcategoryInterface, IdSubOptionInterface } from "../../Context";
import MultiSelectSimple from "../../../../../../../../components/dinamicForm/multiSelectSimple";
import { EvidenceStateValue, UserInfo } from "../../Interfaces";
import { icons } from "../../../../../../../../utils/icons";
import { SnackSimple } from "../../../../../../../../components";
import { Types } from "../../../../../../../../utils/enums/types";
import { Constants } from "../../../../../../../../utils/constants";
import { CategoryFrecuents } from "../../../FormPreventive/Components";
import Loader from "../../../../../../../../components/loader";
import { FolioTypeEndPoint } from "../../../../utils/enums/endpointFolioType";
import { FolioType } from "../../../../utils/enums/folioType";
import { EvidencesTypeValueEnum } from "../../../../../../../../utils/enums/evidences";

export const Step1 = ({ onContinue }: { onContinue: () => void }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { areas, departments, loadDepartmentsByArea, getCategoriesByDepartment, getConfig, config, getCorrectiveData, fetchFrequentOptions, notOptions, options, isOptionsLoaded } = useGetData();
  const { formData, updateFormData, id, isEdit, setIsEdit, configCopy, setConfigCopy } = useContext(FormContext);
  const [selectedCategory, setSelectedCategory] = useState(formData.selectedCategory || null);
  const [selectedSubcategories, setSelectedSubcategories] = useState<SelectedSubcategoryInterface[]>(
    formData.selectedSubcategories?.length ? [formData.selectedSubcategories[0]] : []
  );
  const [subcategoryText, setSubcategoryText] = useState(formData.subcategoryText || "");
  const [selectedArea, setSelectedArea] = useState<ObjectGeneric | null | undefined>(formData.idSubOption ? null : formData.area);
  const [selectedDepartment, setSelectedDepartment] = useState<ObjectGeneric | null | undefined>(formData.idSubOption ? null : formData.department);
  const [categories, setCategories] = useState<CategoryInterface[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingCategories, setIsLoadingCategories] = useState(false);
  const [showConfigWarning, setShowConfigWarning] = useState(false);
  const [hasValidConfig, setHasValidConfig] = useState(true);
  const [flag, setFlaf] = useState(formData.flag ?? true)
  const styles = useStyles();
  const [idSubOption, setIdSubOption] = useState<IdSubOptionInterface | undefined>(formData.idSubOption)

  const checkConfig = async (dataDepartment: ObjectGeneric | null | undefined, area: ObjectGeneric | null | undefined, flag: boolean | undefined) => {
    if (area && dataDepartment) {
      const config = await getConfig(area.id, dataDepartment.value);
      if (!config || (Array.isArray(config) && config.length === 0)) {
        setHasValidConfig(false);
        setShowConfigWarning(true);
        return false;
      }
      if (!!flag) {
        setConfigCopy(
          config.configActionPlanReportFolioEvidenceTypes.filter(
            (item) => item.type === 'CREATE'
          )
        );
        /* setConfigCopy(config.configActionPlanReportFolioEvidenceTypes) */
      }
      //const configExists = config.configActionPlanReportFolioEvidenceTypes && config.configActionPlanReportFolioEvidenceTypes.length > 0;
      const configExists = config.configActionPlanReportFolioEvidenceTypes?.some(
        (item) => item.type === 'CREATE'
      );
      setHasValidConfig(configExists);
      setShowConfigWarning(!configExists);
      return configExists;
    }

    setHasValidConfig(true);
    return true;
  };

  useEffect(() => {

    if (config?.configActionPlanReportFolioEvidenceTypes?.some( (item) => item.type === 'CREATE' )) {

      const evidenceConfig: { [key: number]: EvidenceStateValue } = {};

      const groupedEvidences = formData.evidencesDataEdit?.reduce((acc: any, item: any) => {
        if (item.evidenceTypeId !== undefined) {
          if (!acc[item.evidenceTypeId]) {
            acc[item.evidenceTypeId] = {};
          }
          acc[item.evidenceTypeId][item.originalname] = { name: item.originalname, progress: false, progressAmount: undefined, upload: false, url: item.url }; // Se usa originalname como clave
        } else if (item.comments && Array.isArray(item.comments)) {
          const commentKey = EvidencesTypeValueEnum.COMMENT;
          if (!acc[commentKey]) {
            acc[commentKey] = {};
          }
          item.comments.forEach((comment: string, index: number) => {
            acc[commentKey][comment] = {
              name: comment,
              url: comment
            };
          });
        }
        return acc;
      }, {});

      const mergeConfigurations = (config1: any, config2: any) => {
        const uniqueMap = new Map();

        config1.forEach((item: any) => {
          uniqueMap.set(item.evidenceType.id, { ...item, required: false });
        });

        config2.forEach((item: any) => {
          uniqueMap.set(item.evidenceType.id, item);
        });

        return Array.from(uniqueMap.values());
      }

      const newConfig = !id ? config.configActionPlanReportFolioEvidenceTypes.filter( (item) => item.type === 'CREATE' ) : mergeConfigurations(configCopy, config.configActionPlanReportFolioEvidenceTypes.filter((item) => item.type === 'CREATE' ))

      newConfig.forEach((type: any) => {
        const evidenceType = type.evidenceType;
        const params = type.paramsConfiguration;
        const required = type.required

        evidenceConfig[parseInt(evidenceType.id)] = {
          expanded: false,
          seeFiles: true,
          required: required,
          customeTitle: evidenceType.description || evidenceType.key,
          maxCount: params?.amounts || 10,
          minAmount: type.required ? (params?.min || 1) : 0,
          size: params?.sizes || 5,
          value: !id ? {} : groupedEvidences[evidenceType.id] || {},
          accept: params?.types
            ? params.types.map((t: string) => `.${t}`).join(',')
            : Constants.acceptFile[type.evidenceTypeId.toString()]?.map((t: string) => `.${t}`).join(',')
        };
      });

      updateFormData({
        ...formData,
        evidences: formData.evidences ? formData.evidences : {
          value: evidenceConfig,
          open: false,
          type: {
            equivalence: [],
            accept: '',
          },
        }
      });

    }
  }, [config]);

  useEffect(() => {
    if (!id) {
      fetchFrequentOptions();
    }
  }, []);

  useEffect(() => {
    const loadInitialData = async () => {
      if (selectedArea) {
        try {
          await loadDepartmentsByArea(selectedArea);
          if (selectedDepartment) {
            setIsLoadingCategories(true);

            if (!flag) {
              const fetchedCategories = await getCategoriesByDepartment(selectedDepartment.value, FolioTypeEndPoint.CORRECTIVE);
              setCategories(fetchedCategories);
            } else {
              const fetchedCategories = await getCategoriesByDepartment(selectedDepartment.value, FolioTypeEndPoint.CORRECTIVE);
              const exists = fetchedCategories.find((category: any) => category.id === formData.categoryIdSelected);
              if (!exists && !!selectedSubcategories.length) {
                fetchedCategories.push({
                  id: formData.categoryIdSelected,
                  name: selectedCategory?.name,
                  subcategories: [{
                    categoryId: selectedSubcategories[0].id,
                    id: selectedSubcategories[0].id,
                    name: selectedSubcategories[0].name,
                    requestText: selectedSubcategories[0].requestText,
                    supplierId: selectedSubcategories[0].user.id,
                    priority: selectedSubcategories[0].priority,
                    priorityId: selectedSubcategories[0].priorityId,
                    user: selectedSubcategories[0].user
                  }]
                });
              }

              setCategories(fetchedCategories);
            }
          }
        } catch (error) {
          console.error('Error loading initial data:', error);
        } finally {
          setIsLoading(false);
          setIsLoadingCategories(false);
        }
      } else {
        setIsLoading(false);
      }
    };

    loadInitialData();
  }, [selectedArea, selectedDepartment]);

  const setDateFolio = async () => {
    if (id) {
      const data = await getCorrectiveData(id)
      updateFormData({
        area: {
          value: String(data?.area?.id),
          label: data?.area?.name,
          id: data?.area?.id
        },
        department: {
          value: String(data?.department?.id),
          label: data?.department?.name
        },
        categoryIdSelected: data?.categories ? data?.categories[0].categoryId : undefined,
        selectedCategory: data?.categories ? {name:data.categories[0].category,id:data.categories[0].categoryId} : null,
        selectedSubcategories: data?.categories ?
          [{
            categoryName: data.categories[0].category,
            id: data.categories[0].subcategoryId,
            name: data.categories[0].subcategory,
            requestText: data.categories[0].requestText,
            priority: data.priority,
            priorityId: data.priority?.id,
            user: data?.reportFolioUserAssign?.length ? {
              label: data?.reportFolioUserAssign?.length ? `${data?.reportFolioUserAssign[0].firstName} ${data?.reportFolioUserAssign[0].lastName}` : '',
              id: data?.reportFolioUserAssign?.length ? data?.reportFolioUserAssign[0].id : 0,
            } : null
          }] : [],
        selectedUnit: {
          value: String(data?.store?.id),
          label: data?.store?.name
        },
        selectedPriority: String(data?.priority?.id),
        selectedProvider: data?.reportFolioUserAssign?.length ? {
          value: data?.reportFolioUserAssign?.length ? data?.reportFolioUserAssign[0].id : null,
          label: data?.reportFolioUserAssign?.length ? `${data?.reportFolioUserAssign[0].firstName} ${data?.reportFolioUserAssign[0].lastName}` : null
        } : null,
        selectedProviderCopy: data?.reportFolioUserAssign?.length ? {
          value: data?.reportFolioUserAssign?.length ? data?.reportFolioUserAssign[0].id : null,
          label: data?.reportFolioUserAssign?.length ? `${data?.reportFolioUserAssign[0].firstName} ${data?.reportFolioUserAssign[0].lastName}` : null
        }: null,
        title: data?.name,
        description: data?.description,
        subcategoryText: data?.categories ? data?.categories[0].subcategoryText : undefined,
        evidencesDataEdit: data?.evidences,
        flag: true
      });
      setSelectedArea({
        value: String(data?.area?.id),
        label: data?.area?.name,
        id: data?.area?.id
      })
      setSelectedDepartment({
        value: String(data?.department?.id),
        label: data?.department?.name
      })
      setSelectedCategory(data?.categories ? {name: data.categories[0].category, id:data.categories[0].categoryId}:null)
      setSelectedSubcategories(data?.categories ?
        [{
          categoryName: data.categories[0].category,
          id: data.categories[0].subcategoryId,
          name: data.categories[0].subcategory,
          requestText: data.categories[0].requestText,
          priority: data.priority,
          priorityId: data.priority?.id,
          user: data?.reportFolioUserAssign?.length?  {
            label: data?.reportFolioUserAssign?.length ? `${data?.reportFolioUserAssign[0].firstName} ${data?.reportFolioUserAssign[0].lastName}` : '',
            id: data?.reportFolioUserAssign?.length ? data?.reportFolioUserAssign[0].id : 0,
          }: null
        }] : [])
      setSubcategoryText(data?.categories ? String(data?.categories[0].subcategoryText) : '')
      checkConfig({ value: String(data?.department?.id), label: data?.department?.name }, { value: String(data?.area?.id), label: data?.area?.name, id: data?.area?.id }, true)
    }
  }

  useEffect(() => {
    if (!isEdit && !!id) {
      setDateFolio()
      setIsEdit(true)
    }
  }, [id]);

  const handleCategoryClick = (category: {name:string,id:number}) => {

    if (category == selectedCategory) {
      return
    }

    setFlaf(false)
    setSelectedCategory(category);
    setSelectedSubcategories([]);
    setSubcategoryText("");
    updateFormData({
      selectedSubcategories: [],
      subcategoryText: "",
      flag: false
    });
  };

  const handleAreaChange = async (e: onChangeEvent) => {
    const areaId = e.target.value;
    if (idSubOption) {
      setSelectedSubcategories([]);
      setSelectedCategory(null);
      setSubcategoryText("");
      updateFormData({
        selectedCategory: undefined,
        selectedSubcategories: [],
        subcategoryText: "",
        idSubOption: undefined
      });
    }
    setIdSubOption(undefined)
    if (!areaId) {
      setSelectedArea(null);
      setSelectedDepartment(null);
      setCategories([]);
      if (!flag) {
        setSelectedCategory(null);
        setSelectedSubcategories([]);
        setSubcategoryText("");
        updateFormData({
          area: null,
          department: null,
          selectedCategory: undefined,
          selectedSubcategories: [],
          subcategoryText: "",
          evidences: undefined,
          idSubOption: undefined
        });
      } else {
        updateFormData({
          area: null,
          department: null,
          evidences: undefined,
          idSubOption: undefined
        });
      }
      return;
    }

    setSelectedArea(areaId);
    setSelectedDepartment(null);
    setCategories([]);
    await loadDepartmentsByArea(areaId);

    if (!flag) {
      setSelectedCategory(null);
      setSelectedSubcategories([]);
      setSubcategoryText("");
      updateFormData({
        area: areaId,
        department: null,
        selectedCategory: undefined,
        selectedSubcategories: [],
        subcategoryText: "",
        evidences: undefined,
        idSubOption: undefined
      });
    } else {
      updateFormData({
        area: areaId,
        department: null,
        evidences: undefined,
        idSubOption: undefined
      });
    }
  };

  const handleDepartmentChange = async (e: onChangeEvent) => {
    const departmentId = e.target.value;
    if (idSubOption) {
      setSelectedSubcategories([]);
      setSelectedCategory(null);
      setSubcategoryText("");
      updateFormData({
        selectedCategory: undefined,
        selectedSubcategories: [],
        subcategoryText: "",
        idSubOption: undefined
      });
    }
    setIdSubOption(undefined)
    if (!departmentId) {
      setSelectedDepartment(null);
      setCategories([])
      if (!flag) {
        setSelectedCategory(null);
        setSelectedSubcategories([]);
        setSubcategoryText("");
        updateFormData({
          department: null,
          selectedCategory: undefined,
          selectedSubcategories: [],
          subcategoryText: "",
          categories: [],
          evidences: undefined,
          idSubOption: undefined
        });
      } else {
        updateFormData({
          department: null,
          categories: [],
          evidences: undefined,
          idSubOption: undefined
        });
      }
      return;
    }

    setSelectedDepartment(departmentId);

    if (!flag) {

      setSelectedCategory(null);
      setSelectedSubcategories([]);
      setSubcategoryText("");

      const fetchedCategories = await getCategoriesByDepartment(departmentId.value, FolioTypeEndPoint.CORRECTIVE);
      setCategories(fetchedCategories);
      updateFormData({
        department: departmentId,
        selectedCategory: undefined,
        selectedSubcategories: [],
        subcategoryText: "",
        evidences: undefined,
        idSubOption: undefined
      });
      checkConfig(departmentId, formData.area, false);
    } else {
      const fetchedCategories = await getCategoriesByDepartment(departmentId.value, FolioTypeEndPoint.CORRECTIVE);
      const exists = fetchedCategories.find((category: any) => category.id === formData.categoryIdSelected);
      if (!exists && !!selectedSubcategories.length) {
        fetchedCategories.push({
          id: formData.categoryIdSelected,
          name: selectedCategory?.name,
          subcategories: [{
            categoryId: selectedSubcategories[0].id,
            id: selectedSubcategories[0].id,
            name: selectedSubcategories[0].name,
            requestText: selectedSubcategories[0].requestText,
            priority: selectedSubcategories[0].priority,
            priorityId: selectedSubcategories[0].priorityId,
            supplierId: selectedSubcategories[0].user.id,
            user: selectedSubcategories[0].user
          }]
        });
      }

      setCategories(fetchedCategories);
      //agregar acá la que esta seleccionada
      updateFormData({
        department: departmentId,
        selectedCategory: undefined,
        evidences: undefined,
        idSubOption: undefined
      });
      checkConfig(departmentId, formData.area, false);
    }
  };

  const handleSubcategorySelect = (subcategory: SubcategoryInterface) => {
    if (!selectedCategory) {
      console.warn('No category selected');
      return;
    }

    const isCurrentlySelected = selectedSubcategories.some(sub => sub.id === subcategory.id);

    if (isCurrentlySelected) {
      setSelectedSubcategories([]);
      setSubcategoryText("");
      updateFormData({
        selectedSubcategories: [],
        subcategoryText: ""
      });
    } else {
      let userInfo: UserInfo | null = null;

      if (subcategory.user) {
        userInfo = {
          label: `${subcategory.user.firstName} ${subcategory.user.lastName}`,
          id: subcategory.user.id,
          value: subcategory.user.id
        };
      }

      const newSubcategory: SelectedSubcategoryInterface = {
        id: subcategory.id,
        name: subcategory.name,
        categoryName: selectedCategory.name,
        user: userInfo,
        requestText: subcategory.requestText
      };

      setSelectedSubcategories([newSubcategory]);
      setSubcategoryText("");
      updateFormData({
        selectedSubcategories: [newSubcategory],
        subcategoryText: "",
        selectedProvider: null
      });
    }
  };

  const handleSubcategoryTextChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newText = event.target.value;
    setSubcategoryText(newText);
    updateFormData({ subcategoryText: newText });
  };

  const searchCategories = async () => {
    const fetchedCategories = await getCategoriesByDepartment(formData.department?.value, FolioTypeEndPoint.CORRECTIVE);
    setCategories(fetchedCategories);
    updateFormData({
      categories:fetchedCategories
    });
  }

  useEffect(()=>{
    if(idSubOption){
      searchCategories()
    }
  },[idSubOption])

  const handleOptionSelected = (areaId: number, areaName: string, departmentId: number, departmentName: string, category: string, subCategoriId: number, subCategoryName: string, priorityId: number, userAssigned?: number, userAssignedName?:string) => {

    setSelectedArea(null);
    setSelectedDepartment(null);
    setCategories([]);
    setIdSubOption({ areaId, departmentId, category, subCategoryId: subCategoriId, priorityId, userAssigned })

    const newSubcategory: SelectedSubcategoryInterface = {
      id: subCategoriId,
      name: subCategoryName,
      categoryName: category,
      priority: { id: priorityId, name: '' },
      priorityId: priorityId,
      user: {
        id: userAssigned,
        label: userAssignedName
      }
    };

    setSelectedSubcategories([newSubcategory]);

    updateFormData({
      idSubOption: { areaId, departmentId, category, subCategoryId: subCategoriId, priorityId, userAssigned },
      area: { value: String(areaId), label: areaName, id: areaId },
      department: { value: String(departmentId), label: departmentName, id: departmentId },
      selectedCategory: undefined,
      selectedSubcategories: [newSubcategory],
      selectedProvider: null,
      subcategoryText: "",
      evidences: undefined
    });


    checkConfig({ value: String(departmentId), label: departmentName, id: departmentId }, { value: String(areaId), label: areaName, id: areaId }, false);
  }

  const handleRemoveSelection = () => {
    setSelectedSubcategories([]);
    setSubcategoryText("");
    setIdSubOption(undefined)
    updateFormData({
      selectedSubcategories: [],
      subcategoryText: "",
      idSubOption: undefined
    });
  };

  const handleRegresar = () => {
    navigate("/dashboard/report-folio/dashboard");
  };

  const commonButtonStyles = (isSelected: boolean) => ({
    textTransform: "none",
    borderBottom: isSelected ? "none" : "2px solid #ddd",
    borderRadius: 0,
    backgroundColor: isSelected ? "#1976d2" : "transparent",
    color: isSelected ? "#fff" : "#000",
    "&:hover": {
      backgroundColor: isSelected ? "#1565c0" : "#f0f0f0",
      borderBottom: "2px solid #1976d2",
    },
    padding: "8px 16px",
  });

  const handleContinue = () => {

    if (!idSubOption) {
      if (!selectedCategory || selectedSubcategories.length === 0) return;

      if (shouldShowTextField && !subcategoryText.trim()) {
        return;
      }

      updateFormData({
        selectedCategory,
        selectedSubcategories,
        area: selectedArea,
        department: selectedDepartment,
        categories,
        subcategoryText
      });

      onContinue();
    } else {
      if (selectedSubcategories.length === 0) return;
      onContinue();
    }

    
  };

  const shouldShowTextField = selectedSubcategories.length > 0 &&
    selectedSubcategories[0].requestText;

  if (isLoading) {
    return (<CircularProgress />);
  }




  return (
    <Box mt={2}>
      {isOptionsLoaded ?
        <Loader/>
        :
        <>
          {!notOptions && !id ?
            <>
              <Box mb={2}>
                <Typography variant="body1" fontWeight="bold">
                  {t("reportFolio.forms.MostFrecuenceSelection")}
                </Typography>
              </Box>
              <Grid container spacing={2}>
                {options.map((option, index) => (
                  <Grid
                    item
                    xl={3}
                    xs={6}
                    sm={6}
                    md={6}// 3 columnas en pantallas grandes (4 elementos en una fila)
                    key={index}
                  >
                    <CategoryFrecuents {...option} onClickCorrective={handleOptionSelected} typeFolio={FolioType.CORRECTIVE} idSubOptionCorrective={idSubOption} />
                  </Grid>
                ))}
              </Grid>
            </>
            :
            <></>
          }
        </>
      }

      <Grid container spacing={4} mt={4}>
        <Grid item xs={6} sm={6} xl={3.2} sx={styles.gestionZoneGrid}>
          <Box sx={styles.gestioneZoneBox}>
            <Typography variant="body1" fontWeight={"bold"}>{t("reportFolio.forms.gestionZone")}</Typography>
            <MultiSelectSimple
              isRequired
              name="Area"
              label={"Área *"}
              onChange={handleAreaChange}
              items={areas}
              selected={selectedArea}
            />
            <MultiSelectSimple
              isRequired
              name="Departamento"
              label={"Departamento *"}
              onChange={handleDepartmentChange}
              items={departments}
              selected={selectedDepartment}
              disabled={!selectedArea}
            />
          </Box>
        </Grid>

        <Grid item xs={6} sm={6} xl={4.8} sx={styles.categoryAndSubCategoryGrid}>
          <Typography variant="body1" fontWeight="bold" mb={1}>
            {t("reportFolio.forms.selectCategories")}
          </Typography>

          <Box display="flex" flexDirection="column" gap={2}>
            <Box display="flex" alignItems="flex-start" gap={2}>
              <Box display="flex" flexDirection="column" gap={1} sx={{ minWidth: "30%" }}>
                {isLoadingCategories ? (
                  <CircularProgress />
                ) : (categories.length === 0 && selectedDepartment ? (
                  <Box sx={{ textAlign: "center", color: "#999", fontStyle: "italic", padding: "8px" }}>
                    {t('reportFolio.detail.general.departmentWithoutCategories')}
                  </Box>
                ) : (
                   !idSubOption && categories.map((category, index) => (
                    <Button
                      key={index}
                      onClick={() => handleCategoryClick({name:category.name,id:category.id})}
                      sx={{
                        ...commonButtonStyles(selectedCategory?.id === category.id)
                      }}
                    >
                      {category.name}
                    </Button>
                  ))
                ))}
              </Box>

              <Box display="flex" flexDirection="column" gap={1} sx={{ minWidth: "30%" }}>
                {!idSubOption && selectedCategory && !isLoadingCategories && (
                  categories
                    .find((cat) => cat.id === selectedCategory.id)
                    ?.subcategories.map((sub: any, idx: number) => {
                      const isSelected = selectedSubcategories.some(selected => selected.id === sub.id);
                      return (
                        <Button
                          key={idx}
                          onClick={() => handleSubcategorySelect(sub)}
                          sx={{
                            ...commonButtonStyles(isSelected)
                          }}
                        >
                          {sub.name}
                        </Button>
                      );
                    })
                )}
              </Box>
            </Box>

            {shouldShowTextField && !!categories.length && !isLoadingCategories && (
              <Box sx={{ width: "100%" }}>
                <TextField
                  fullWidth
                  label="Detalle *"
                  variant="outlined"
                  value={subcategoryText}
                  onChange={handleSubcategoryTextChange}
                  multiline
                  rows={2}
                  sx={{
                    width: {
                      md: '94%',
                      xl: 'calc(77% - 16px)'
                    },
                    marginLeft: "0px"
                  }}
                />
              </Box>
            )}
          </Box>
        </Grid>

        <Grid item xs={12} sm={6} xl={4}>
          <Typography variant="body1" fontWeight="bold" mb={1}>
            {t("reportFolio.forms.categoriesSelected")}
          </Typography>
          <Box sx={styles.categoriesSelected}>
            {idSubOption || !selectedSubcategories.length ?
              (
                <Box sx={styles.containerNoCategories}>
                  {icons('info-outlined')}
                  <Typography>{t("reportFolio.forms.noCategoriesSelected")}</Typography>
                </Box>
              )
              :
              (
                <>
                  {selectedSubcategories.map((sub) => (
                    <Chip
                      key={sub.id}
                      label={`${sub.categoryName} - ${sub.name}`}
                      onDelete={handleRemoveSelection}
                      sx={{ margin: 0.5 }}
                    />
                  ))}
                </>
              )
            }
          </Box>
        </Grid>
      </Grid>

      <Box sx={styles.btnsContainer}>
        <Button onClick={handleRegresar} sx={styles.btnBack}>
          {t("reportFolio.forms.back")}
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={handleContinue}
          sx={{borderRadius:'4px'}}
          disabled={
            !idSubOption &&
            (
              !selectedArea ||
              !selectedDepartment ||
              !selectedCategory ||
              selectedSubcategories.length === 0 ||
              (shouldShowTextField && !subcategoryText.trim()) ||
              !hasValidConfig ||
              isLoadingCategories
            )
          }
        >
          {t("reportFolio.forms.continue")}
        </Button>
      </Box>

      <SnackSimple
        open={showConfigWarning}
        close={() => setShowConfigWarning(false)}
        message="Para crear un folio en esta área y departamento, debes crear una configuración."
        type={Types.INFO}
      />
    </Box>
  );
};